// J-232 (the owner's inbox file 33, item 4): who sees the performance groups outside Performance — the
// Practice report's group view and the Quality report's group filter. The same signal as Performance's
// group view (J-202, `routes/_authenticated/groups/index.tsx`): `acoQuality.read`, which the ACO-wide
// roles hold and the practice roles and the clinician do not (CRQ-023). The server stays the authority:
// it answers 403 to a `group` from a role without ACO-wide scope.
// J-238 (group access): a user whose `/me/access` says `scopeKind: "group"` carries a group too, one of
// its own grants (`lib/group-access.ts` replaces any other before a read is sent).
import type { MyAccess } from "@vbltc/schema";
import { isRoleName, roles } from "@vbltc/schema/permissions";

export function hasGroupScope(
  role: string | null | undefined,
  scopeKind?: MyAccess["scopeKind"],
): boolean {
  if (scopeKind === "group") return true;
  return isRoleName(role) && roles[role].authorize({ acoQuality: ["read"] }).success;
}
